var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.gridColHeight") } },
        [
          _c("el-input", {
            staticClass: "hide-spin-button",
            attrs: { type: "number", min: "0" },
            nativeOn: {
              input: function ($event) {
                return _vm.inputNumberHandler($event)
              },
            },
            model: {
              value: _vm.optionModel.colHeight,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "colHeight", $$v)
              },
              expression: "optionModel.colHeight",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }